import Dynamic from '@base/Dynamic/Dynamic';

const FreePlanModal = Dynamic(() => import('./FreeTrial/FreePlanModal'));
const ExpiredSubscriptionModal = Dynamic(() =>
  import('./FreeTrial/ExpiredSubscriptionModal')
);

const FreeTrialModal = ({
  goalInfo,
  isLoggedIn,
  isActivateFreeTrialClicked,
  hadFreeTrialSubscription
}) => {
  const showExpiryNudge = !goalInfo?.trialExpiryPopUpShown;
  const showFreePlanNudge = !showExpiryNudge && isActivateFreeTrialClicked;
  if (
    !isLoggedIn ||
    !hadFreeTrialSubscription ||
    goalInfo?.trialExpiryPopUpShown === undefined
  )
    return null;
  return (
    <>
      <ExpiredSubscriptionModal open={showExpiryNudge} />
      <FreePlanModal open={showFreePlanNudge} />
    </>
  );
};
export default FreeTrialModal;
